import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M21.8 3.263c-.264-.12-.68-.189-.827-.213C20.67 3 20.36 3 19.629 3H4.37c-.73 0-1.04 0-1.343.05 0 0-.415.024-.827.213A2.06 2.06 0 0 0 1 5.123v.95a2.07 2.07 0 0 0 1 1.78l.81 11.35A3.15 3.15 0 0 0 6 22.073h12a3.15 3.15 0 0 0 3.13-2.92L22 7.803a2.07 2.07 0 0 0 1-1.73v-.9a2.06 2.06 0 0 0-1.2-1.91M10 8.073v3h4v-3zm-5.71 3H8v-3H4.07zm3.71 2H4.43l.22 3H8zm6 3v-3h-4v3zm5.57-3H16v3h3.35zm-3.57-2h3.71l.22-3H16zM3 5.123v.95h18v-.9zm2.227 14.642c.21.196.486.306.773.308h2v-2H4.79l.08.94c.02.287.148.555.357.752M10 18.073v2h4v-2zm6 2h2a1.14 1.14 0 0 0 1.14-1.06l.07-.94H16z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }